export default __webpack_public_path__ + "static/media/propeller-logo.10069d05.svg";